import { useEffect, useState } from 'react';
import { INSTALLER_ERRORS } from '../errors';
import { fetchIdentityUserToken } from '../services/fetch-identity-user-token';
import { loadExperiments } from '../services/experiments';
import { initI18n } from '../services/i18n';
export const useInstallerPrerequisites = _ref => {
  let {
    essentials: {
      httpClient
    },
    panoramaClient,
    appId,
    messagesPromise,
    topology
  } = _ref;
  const [prerequisitesState, setPrerequisitesState] = useState({
    isDetermined: false
  });
  useEffect(() => {
    (async () => {
      const errors = [];
      const prerequisitesTransaction = panoramaClient == null ? void 0 : panoramaClient.transaction('fetch-prerequisites');
      prerequisitesTransaction == null || prerequisitesTransaction.start({
        appId
      });
      await Promise.all([loadExperiments(errors), fetchIdentityUserToken(httpClient, errors), initI18n({
        errors,
        topology,
        httpClient,
        messagesPromise
      })]).finally(() => {
        prerequisitesTransaction == null || prerequisitesTransaction.finish({
          appId
        });
      });
      let prerequisiteError;
      if (errors.length) {
        prerequisiteError = {
          error: new Error(JSON.stringify(errors)),
          ...INSTALLER_ERRORS.FAILED_TO_LOAD_PREREQUISITES
        };
      }
      setPrerequisitesState({
        isDetermined: true,
        error: prerequisiteError
      });
    })();
  }, []);
  return {
    prerequisitesState
  };
};
//# sourceMappingURL=useInstallerPrerequisites.js.map